<div
  class="d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1"
  role="document"
  aria-labelledby="confirmation-title"
>
  <div>
    <div class="fgbcl-confirmation-header">
      <div class="fgbcl-rewards-purchase-confirmation-title" id="confirmation-title">
        {{ 'auction.confirm.text' | translate }}
      </div>
    </div>

    <div class="fgbcl-confirmation-body">
      <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.confirmation.additional'">
        <div class="font-size-14 text-black fw-bold rewards-confirmation-additional">
          {{ 'auctions.confirmation.additional' | translate }}
        </div>
      </ng-container>

      <div class="confirmation-details-section">
        <img
          class="confirm-modal-image"
          src="{{ auctionItem.ImageUrl | contentImage: '7' : 'auction' }}"
          draggable="false"
          [alt]="auctionItem.ItemName"
        />
        <div class="fgbcl-confirmation-details">
          <div class="purchase-confirmation-name">{{ auctionItem.ItemName }}</div>
          <div class="auction-modal-points-value">
            <span class="mpc-confirmation-spacing">{{ 'auction.points.value' | translate }}</span>
            <span class="fw-bold auction-confirmation-amount">
              {{ bidAmount | number }} {{ 'fgbcl.currency.pts' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="fgbcl-confirmation-footer">
    <button id="cancel-button" type="button" class="fgbcl-confirmation-button btn btn-purchase-cancel" (click)="modal.close()">
      {{ 'modal.cancel' | translate }}
    </button>
    <button id="confirm-button" type="button" class="fgbcl-confirmation-button btn btn-purchase-confirm" (click)="submitBid()">
      {{ 'modal.confirm' | translate }}
    </button>
  </div>
</div>
